module.exports = __webpack_public_path__ + "img/sanic.e071ee00.png";